// eslint-disable-next-line jira/filename-case
import React, { useMemo, type ReactNode } from 'react';
import {
	RelayEnvironmentProvider,
	useRelayEnvironment,
	type IEnvironmentProvider,
} from 'react-relay';
import getRelayEnvironment from '@jira/platform__graphql-relay-environment/src/index.tsx';

export default function JiraRelayEnvironmentProvider({
	children,
}: {
	children: ReactNode;
}): React.JSX.Element {
	return (
		<RelayEnvironmentProvider environment={getRelayEnvironment()}>
			{children}
		</RelayEnvironmentProvider>
	);
}

export function useJiraRelayEnvironmentProvider(): IEnvironmentProvider<{}> {
	const environment = useRelayEnvironment();

	return useMemo(
		() => ({
			getEnvironment() {
				return environment;
			},
		}),
		[environment],
	);
}
